module.exports = __webpack_public_path__ + "static/06-e5aad1a4b48e44344c60a26ca0bbef72.jpg";